import { BoxStyleProps } from "@twilio-paste/core/box";
import { TextStyleProps } from "@twilio-paste/core/text";

export const formStyles: BoxStyleProps = {
    padding: "space40",
    paddingTop: "space80",
    overflow: "auto"
};

export const titleStyles: TextStyleProps = {
    fontSize: "fontSize70",
    marginBottom: "space60"
};

export const introStyles: TextStyleProps = {
    marginBottom: "space70"
};

export const fieldStyles: BoxStyleProps = {
    marginBottom: "space70"
};

export const formButtonStyles: BoxStyleProps = {
    display: "flex",
    justifyContent: "center"
};

export const loadingStyles: BoxStyleProps = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "fixed",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
};

// export const fount: BoxStyleProps = {
//     display: "inline-block"
//     // margin: "10px 20px",
//     // background: "#A9A9A9",
// };
